export default __webpack_public_path__ + "static/media/i241sp.b033034f.webp";